// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

// Prod server
const firebaseConfig = {
 apiKey: 'AIzaSyCFsEkgggv2g3sKFKedKPkNqU6sFjzfl5o',
 authDomain: 'djuli-zp.firebaseapp.com',
 projectId: 'djuli-zp',
 storageBucket: 'djuli-zp.appspot.com',
 messagingSenderId: '353283799832',
 appId: '1:353283799832:web:87051e3baaf5c480a87c6d',
};
//Dev server
// const firebaseConfig = {
//  apiKey: 'AIzaSyC36ZVcrmA11iv7dqDy7CCwaLUOITTNw0Q',
//  authDomain: 'djuli-dev-zp.firebaseapp.com',
//  projectId: 'djuli-dev-zp',
//  storageBucket: 'djuli-dev-zp.appspot.com',
//  messagingSenderId: '353980099431',
//  appId: '1:353980099431:web:06d86d991b4818e9229dc2'
// };

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const storage = getStorage(firebaseApp);

export default {storage, firebaseApp}
